export interface IDeviceAssignment {
  id: string;
  deviceId: string;
}
